import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { FormGroup } from '@angular/forms';
import { tap, delay } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { RequestStatus } from 'src/app/shared/data/models';

@Component({
  selector: 'app-loginsucces',
  templateUrl: './loginsucces.component.html',
  styleUrls: ['./loginsucces.component.scss']
})
export class LoginsuccesComponent implements OnInit, OnDestroy {

  private subs = new SubSink();
  public statusDetail: RequestStatus = 'init';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FormGroup,
    public router: Router,
    private authService: AuthService,
    public dialogRef: MatDialogRef<LoginsuccesComponent>
  ) { };

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  };

  ngOnInit(): void {
    this.closeModal();
  }

  public closeModal(): void {
    this.accesLogin(this.data)
  }

  public accesLogin(form: FormGroup): void {
    this.subs.sink = this.authService.login(form)
      .pipe(
        tap(() => this.statusDetail = 'success'),
        delay(2000)
      )
      .subscribe({
        next: () => {
          this.statusDetail = 'success';
          this.router.navigateByUrl('/home/dashboard');
          this.dialogRef.close();
        },
        error: (error) => {
          this.statusDetail = 'error';
          this.dialogRef.close();
        }
      })
  };

}
